import { SearchEngine } from './common'
import { defaultOperatorName } from '@/utils/constants'

const defaultFieldSpecifiers = [
  { name: 'title' },
  { name: 'from' },
  { name: 'to' }
]

const MAX_QUERY_LENGTH = 1488

const defaultSyntaxGuideUrl = 'https://blog.tripdatabase.com/2017/10/13/boolean-truncation-and-other-such-things/'

class TripEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('Trip Database')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  mapOperator (operator) {
    switch (operator.toUpperCase()) {
      case 'AND': return { op: '', spaces: true }
      case 'OR': return { op: 'OR', spaces: false }
      case 'NOT': return { op: 'NOT', spaces: true }
    }
    return { op: operator, spaces: true }
  }
  formulateQueryFromNodeData (nodeData) {
    const baseTerm = nodeData.text.replace(SearchEngine.quoteReplaceRE, '\\"')
    return this.formTerm(baseTerm, nodeData.isNegative, this.addQuotes(baseTerm),
      nodeData.fieldSpecifier)
  }
  addQuotes (baseTerm) {
    return this.addQuotesAroundPhrases && baseTerm && baseTerm.indexOf(' ') > 0
  }
  formTerm (text, isNegative, addQuotes, fieldSpecifier) {
    let r = '('
    if (isNegative) {
      r += 'NOT '
    }
    if (fieldSpecifier && fieldSpecifier.length > 0) {
      r += fieldSpecifier + ':'
    }
    if (addQuotes) {
      r += '"'
    }
    r += text
    if (addQuotes) {
      r += '"'
    }
    r += ')'
    return encodeURIComponent(r)
  }
  formulateQuery (query) {
    return 'https://www.tripdatabase.com/search?lang=en&criteria=' + query
  }
  formulateQueryFromTreeDataInternal (treeData) {
    if (typeof treeData.children === 'undefined') {
      return this.formTerm(treeData.text)
    }
    let r = ''
    let isFirst = true
    const thisOperator = treeData.operator || defaultOperatorName
    const mappedThisOperator = this.mapOperator(thisOperator)
    const thisChildrenCount = treeData.children.length
    for (const i of treeData.children) {
      if (i.isOperator) {
        continue
      }
      if (this.isPrefixOperator(thisOperator)) {
        r += mappedThisOperator.op
      } else if (!isFirst) {
        if (mappedThisOperator.spaces) {
          r += ' '
        }
        r += mappedThisOperator.op
        if (mappedThisOperator.spaces && mappedThisOperator.op !== '') {
          r += ' '
        }
      }
      if (isFirst) {
        isFirst = false
      }
      if (i.children && i.children.length > 0) {
        const addBrackets = i.isNegative || thisChildrenCount > 1
        if (addBrackets) {
          r += '('
        }
        if (i.isNegative) {
          r += 'NOT '
        }
        r += this.formulateQueryFromTreeDataInternal(i)
        if (addBrackets) {
          r += ')'
        }
      } else {
        r += this.formTerm(i.text, i.isNegative, this.addQuotes(i.text), i.fieldSpecifier)
      }
    }
    r = this.lastPass(r)
    return r
  }
  lintQuery (queryGraphData) {
    // Check for any field specifiers used that are not in the supported list
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    const r = m ? [m] : []
    // Check for query being too long
    const q = this.formulateQueryFromTreeData(queryGraphData)
    if (q && q.length > MAX_QUERY_LENGTH) {
      r.push(this.formatErrorMessage('charLimit', MAX_QUERY_LENGTH))
    }
    return r
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsMeshSettings()
  }
}

export default TripEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/TripEngine.js